var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 15.4766H11V14.4766H4V15.4766ZM4 11.4766H11V10.4766H4V11.4766ZM2.11537 18.9766C1.65512 18.9766 1.27083 18.8224 0.9625 18.5141C0.654167 18.2057 0.5 17.8214 0.5 17.3612V2.59194C0.5 2.13169 0.654167 1.7474 0.9625 1.43906C1.27083 1.13073 1.65512 0.976562 2.11537 0.976562H10L14.5 5.47656V17.3612C14.5 17.8214 14.3458 18.2057 14.0375 18.5141C13.7292 18.8224 13.3449 18.9766 12.8846 18.9766H2.11537ZM9.5 5.97656V1.97656H2.11537C1.96154 1.97656 1.82052 2.04066 1.6923 2.16886C1.5641 2.29708 1.5 2.4381 1.5 2.59194V17.3612C1.5 17.515 1.5641 17.656 1.6923 17.7843C1.82052 17.9125 1.96154 17.9766 2.11537 17.9766H12.8846C13.0385 17.9766 13.1795 17.9125 13.3077 17.7843C13.4359 17.656 13.5 17.515 13.5 17.3612V5.97656H9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.eedf425bebf4c1c2e174abff630ff3f7.svg";
export { ForwardRef as ReactComponent };